// El backend no expone un campo "origen de carga": se infiere agrupando roles
// (PREVENTOR vs. OPERADOR_SIMP/SUPERVISOR_SIMP). Este enum fija ese contrato
// para el filtro hasta que el backend lo soporte de forma nativa.
export enum ORIGEN_CARGA_ROL {
    PREVENTOR = 'PREVENTOR',
    OPERADOR_SUPERVISOR = 'OPERADOR_SUPERVISOR'
}
